<template>
  <BaseShowEditRadio
    v-model="selectedValues"
    :edition-mode="editionMode"
    name="payment_status"
    :options="paymentStatuses"
    :label="$t('attributes.payment_status')"
    :errors="errors"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import BaseShowEditRadio from '@c/addf-package/components/BaseShowEditRadioGroup/BaseShowEditRadio.vue'

export default {
  name: 'SelectPaymentStatuses',
  components: { BaseShowEditRadio },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters('metadata', {
      paymentStatuses: 'getPaymentStatusesMetadata'
    }),
    selectedLabel() {
      return this.paymentStatuses.find(
        (paymentStatus) => paymentStatus.id === this.modelValue
      )?.name
    }
  }
}
</script>
